import type { LevelDef } from '../level.ts';

// Three near-parallel strips all pointing the same way, the way the real
// mega-hub is laid out: no crossings at all, just three streams arriving from
// the same side that have to be kept apart from each other. Each strip is
// staggered and tilted a little against its neighbour — dead parallel and
// level with each other, they read as a bar chart.
export const istanbul: LevelDef = {
  id: 'istanbul', city: 'istanbul', country: 'turkey',
  blurb: 'black sea fog, three strips one way, streams to keep apart',
  baseline: 505, scoreMul: 2,
  capBase: 3, capDiv: 4, capMax: 6,
  spawnLead: [6, 12], minSpawnGap: 1.9, tempo: 1,
  mix: [['light', 0.24], ['medium', 0.32], ['heavy', 0.24], ['jet', 0.20]],
  layout: {
    runways: [
      { x1: -0.64, y1: 0.60, x2: -0.58, y2: -0.50 },
      { x1: -0.18, y1: 0.50, x2: -0.10, y2: -0.60 },
      { x1: 0.32, y1: 0.62, x2: 0.44, y2: -0.34 },
    ],
    pads: [],
  },
  palette: { bg: '#f5f2ee', field: '#e5e0d6', deep: '#dad3c6', water: '#c6d6de' },
  decor: ['domes', 'minarets'],
  // the Black Sea across the top — the coast the airport was built against
  water: [{ x: 0, y: 0 }, { x: 1, y: 0 }, { x: 1, y: 0.11 }, { x: 0.58, y: 0.15 }, { x: 0, y: 0.09 }],
  arrivalSides: [0.7, 1, 1.3, 1],
  // d4 kumoi: contemplative
  music: { root: 62, mode: 'kumoi', bpm: 60, wind: 0.5, verb: 0.6, bright: 2800 },
};
